import React from 'react';

import { Flex } from '@chakra-ui/react';
import { ICellRendererParams } from 'ag-grid-community';
import { employeeMiniProfile } from 'interfaces/EmployeeMiniProfile';
import { z } from 'zod';

import { Avatar } from 'uiToolkitV1/Avatar';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { OneOnOneInsightsTData } from '../../features/AgGridTable/services';

type Props = z.infer<typeof employeeMiniProfile>;

const EmployeeCell = ({ value }: ICellRendererParams<OneOnOneInsightsTData, Props>) => {
  const { displayName, profilePhoto } = value ?? {};
  return (
    <Flex w="100%" h="100%" alignItems="center">
      <Avatar name={displayName} src={profilePhoto} />
      <Flex flexDirection="column" ml="2">
        <TextBodyMedium>{displayName}</TextBodyMedium>
      </Flex>
    </Flex>
  );
};

export { EmployeeCell };
